var elem = document.querySelector('.outfit_mob_slider');
if (elem) {
  var flkty = new Flickity(elem, {
    // options
    cellAlign: 'left',
    contain: true,
    watchCSS: true,
    groupCells: true,
    pageDots: false
  });
}

var designerSlider = document.querySelector('.designer_slider');
if (designerSlider) {
  var flkty = new Flickity(designerSlider, {
    // options
    cellAlign: 'left',
    contain: true,
    groupCells: true,
    pageDots: false
  });
}


var relatedSlider = document.querySelector('.product-recommendations--loaded .flickty_slider');
if (relatedSlider) {
  var flkty = new Flickity(relatedSlider, {
    // options
    cellAlign: 'left',
    contain: true,
    groupCells: true,
    pageDots: false
  });
}

/**
 * Scroll to top
 */
{
  let scrollBtn = document.getElementById("scrollToTopBtn");
  if (scrollBtn) {
    scrollBtn.addEventListener('click', () => {
      scrollToTop();
    });

    window.onscroll = function () {
      scrollBtn.style.display = (document.body.scrollTop > 20 || document.documentElement.scrollTop > 100) ? "block" : "none";
    };

    function scrollToTop() {
      var currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentPosition > 0) {
        window.requestAnimationFrame(scrollToTop);
        window.scrollTo(0, currentPosition - currentPosition / 8);
      }
    }
  }
}

/**
 * Scroll to section
 */
{
  document.querySelectorAll('.js-sctoll-to-section-btn').forEach((element) => {
    element.addEventListener('click', (event) => {
      event.preventDefault();

      let headerHeight = parseFloat(document.querySelector('.js-header-height').style.getPropertyValue('--header-height'));
      let brandItemId = element.dataset.scrollTo || element.getAttribute('href');
      let brandDirectoryHeight = document.querySelector(brandItemId).offsetTop;

      window.scrollTo({
        top: brandDirectoryHeight - headerHeight,
        behavior: "smooth",
      });

    });
  });

}

/**
 * Tooltio script
 */
{
  tippy('[data-tippy-content]', {
    content: "sold out",
    arrow: true,
    placement: 'bottom',
    role: 'tooltip',
    allowHTML: true,
  });
}


/**
 * Grid alignment Script
 */
{

  window.setGridHeight = (selector) => {
    let gridOffsets = [];
    let gridRowOffsets = []

    gridOffsets = Array.from(document.querySelectorAll(selector)).map((element, index) => {
      let grid = element.closest('.grid__item') || element.closest('[data-equal]');
      element.removeAttribute('style');
      return {
        selector: element,
        selectorHeight: element.offsetHeight,
        offsetTop: grid.offsetTop,
      }
    });

    let offsets = gridOffsets.map(element => element.offsetTop);
    gridRowOffsets = [...new Set(offsets)];

    gridRowOffsets.forEach(rowOffset => {
      let rowGrids = gridOffsets.filter(grid => (grid.offsetTop == rowOffset));
      let comanElementHeight = Math.max.apply(Math, (rowGrids.map(ele => ele.selectorHeight)));
      rowGrids.forEach(grid => {
        grid.selector.style.minHeight = comanElementHeight + 'px';
      });
    });
  }

  setTimeout(() => {
    window.matchHeightCallback();
  }, 2000)

  window.addEventListener('resize', function (event) {
    window.matchHeightCallback();
  });

  window.matchHeightCallback = () => {
    window.setGridHeight('.product-card-wrapper .card__heading');
  }
  window.matchHeightCallback();
}

document.addEventListener('DOMContentLoaded', function () {
  let mainCollectionWrapper = document.querySelector('.js-main-collection');
  let searchCollectionContainer = document.querySelector('.js-search-inner');
  if (mainCollectionWrapper) {
    localStorage.getItem('collectionProductView') == 'true' ? mainCollectionWrapper.classList.add('outfit-active') : mainCollectionWrapper.classList.remove('outfit-active');
  }
  if (searchCollectionContainer) {
    localStorage.getItem('searchProductView') == 'true' ? searchCollectionContainer.classList.add('outfit-active') : searchCollectionContainer.classList.remove('outfit-active');
  }
});

// document.querySelectorAll('a[href*="/collections/"]:not([href*="/products/"]):not([href*="/collections/all"])').forEach(link => {
//   let linkURL = new URL(link.href)
//     , searchParams = linkURL.searchParams;
//   if (!searchParams.get("sort_by")) {
//     searchParams.append("sort_by", "created-descending");
//     let newURL = linkURL.pathname + linkURL.search;
//     link.setAttribute("href", newURL)
//   }
// });


const outfitBtn = document.querySelector('.js-mobile-outfit-btn');

if (outfitBtn) {

  outfitBtn.addEventListener('click', function (event) {
    event.preventDefault();

    const mainCollectionContainer = this.closest('.js-main-collection');
    const searchContainer = this.closest('.js-search-inner');
    let collectionProductView = localStorage.getItem('collectionProductView') === 'true';
    let searchProductView = localStorage.getItem('searchProductView') === 'true';

    if (mainCollectionContainer) {
      mainCollectionContainer.classList.toggle('outfit-active', !collectionProductView);
      localStorage.setItem('collectionProductView', !collectionProductView);
    }
    if (searchContainer) {
      searchContainer.classList.toggle('outfit-active', !searchProductView);
      localStorage.setItem('searchProductView', !searchProductView);
    }

  });
}

// js for password show hide

{

  let viewPassword = document.querySelectorAll('.js-view-password');

  viewPassword.forEach(element => {
    element.addEventListener('click', function () {
      let passwordField = this.closest('.field_password').querySelector('.js-password-field');
      if (passwordField) {
        passwordField.type = passwordField.type === 'password' ? 'text' : 'password';
      }
    });
  });

}

// shop look scroll to wear it section product page
{
  let shopLookScroll = document.querySelector('.js-shop-look-btn');
  if (shopLookScroll) {

    shopLookScroll.addEventListener('click', (event) => {
      event.preventDefault();

      let headerHeight = parseFloat(document.querySelector('.js-header-height').style.getPropertyValue('--header-height'));
      let shopLookBtn = shopLookScroll.getAttribute('data-section-id');
      let target = document.querySelector(shopLookBtn);
      if (!target) return;
      let wearItSection = target.offsetTop;

      window.scrollTo({
        top: wearItSection - headerHeight,
        behavior: "smooth",
      });
    });

  }
}

// match password and confirm password

{
  let passwordField = document.querySelector('.js-match-password');
  let confirmPasswordField = document.querySelector('.js-match-confirm-password');
  let submitBtn = document.querySelector('.js-submit-btn');

  let passwordFieldMessage = document.createElement('span');
  passwordFieldMessage.style.color = 'red';
  if (passwordField) {
    passwordField.parentNode.appendChild(passwordFieldMessage);
  }

  let message = document.createElement('span');
  message.style.color = 'red';
  if (confirmPasswordField) {
    confirmPasswordField.parentNode.appendChild(message);
  }

  function checkPasswordFieldLength() {
    if (passwordField.value.length === 0) {
      confirmPasswordField.setAttribute('disabled', 'disabled');
      return false;
    }
    else if (passwordField.value.length < 5) {
      passwordFieldMessage.textContent = 'Password is too short (minimum is 5 characters).';
      submitBtn.setAttribute('disabled', 'disabled');
      return false;
    } else {
      confirmPasswordField.removeAttribute('disabled');
      submitBtn.removeAttribute('disabled');
      passwordFieldMessage.textContent = '';
      return true;
    }
  }

  function checkPasswordMatch() {
    if (passwordField.value !== confirmPasswordField.value) {
      submitBtn.setAttribute('disabled', 'disabled');
      message.textContent = 'Passwords do not match.';
    } else {
      submitBtn.removeAttribute('disabled');
      message.textContent = '';
    }
  }

  if (passwordField) {
    checkPasswordFieldLength();
    passwordField.addEventListener('input', checkPasswordFieldLength);
  }
  if (confirmPasswordField) {
    confirmPasswordField.addEventListener('input', checkPasswordMatch);
  }
}

/**
 * Custom popup
 */
{
  class customPopup extends HTMLElement {
    constructor() {
      super();
      this.querySelector('.js-btn-close').addEventListener('click', this.close.bind(this));
      this.querySelector('.js-btn-open').addEventListener('click', this.open.bind(this));
      this.querySelector('.js-popup-overlay').addEventListener('click', this.close.bind(this));
    }
    close() {
      this.classList.remove('open');
      document.body.classList.remove('overflow-hidden');
    }
    open() {
      this.classList.add('open');
      document.body.classList.add('overflow-hidden');
    }
  }
  customElements.define('custom-popup', customPopup);
}

// js for stylist corner accordian

{
  function initializeTabs(tabSelector, isMobileTab) {
    let tabs = document.querySelectorAll(tabSelector);

    if (tabs.length > 0) {
      tabs.forEach((element) => {
        element.addEventListener('click', function () {
          let currentTitle = this.dataset.tabName;
          tabs.forEach(tabLink => {
            tabLink.classList.toggle("active", tabLink === element);
          });
          document.querySelectorAll('.js-tabs-accordian').forEach((item) => {
            item.classList.toggle('hidden', !item.dataset.accordianName.split(',').includes(currentTitle));
          });
          if (isMobileTab) {
            let dropdown = this.closest('details');
            dropdown.querySelector('.js-mobile-tab-name').innerHTML = element.innerHTML;
            dropdown.removeAttribute('open');
          }
        });
      });
      tabs[0].click();
    }
  }

  initializeTabs('.js-tabs');
  initializeTabs('.js-mobile-tabs', true);
}

// Save my bag modal

{
  let modalCloseBtn = document.querySelectorAll('.js-modal-close-btn');
  if (modalCloseBtn) {
    modalCloseBtn.forEach((element) => {
      element.addEventListener('click', function () {
        this.closest('modal-dialog').hide();
      })
    })
  }
}

// Account page javascript

{

  let accountPageTabs = document.querySelectorAll('.js-account-page-tabs');
  let tabNameMob = document.querySelector('.js-account-page-tab-name-mob');
  let buttonwrapper = document.querySelector((window.matchMedia("(max-width: 749px)").matches) ? '.mobile_select.account_mobile_menu ' : '.desktop-sidebar');
  let isAccountPage = document.body.classList.contains('template-name--account');

  function updateButtonWrapper() {
    buttonwrapper = document.querySelector((window.matchMedia("(max-width: 749px)").matches) ? '.mobile_select.account_mobile_menu ' : '.desktop-sidebar');
  }

  if (accountPageTabs) {
    accountPageTabs.forEach((element) => {

      element.addEventListener('click', function (event) {
        if (!isAccountPage) {
          window.sessionStorage.setItem('accountActivetab', this.getAttribute('data-tab-linkto'));
          return;
        }
        event.preventDefault();

        if (tabNameMob) {
          tabNameMob.innerHTML = this.innerHTML;
          if(this.closest('details')) this.closest('details').removeAttribute('open');
        }

        buttonwrapper.querySelectorAll('.js-account-page-tabs').forEach((tab) => {
          tab.classList.toggle('active', (tab.dataset.tabLinkto == element.dataset.tabLinkto));
        });

        let tabContents = document.querySelectorAll('.js-details-inner');
        let linkTo = this.getAttribute('data-tab-linkto');
        tabContents.forEach((content) => {
          content.classList.toggle('hidden', !(content.id == linkTo));
        });
        window.sessionStorage.setItem('accountActivetab', linkTo);
        if (isAccountPage) {
          window.scrollTo({
            behavior: "smooth",
            top: (document.querySelector('.account-main--wrapper').offsetTop - document.querySelector('sticky-header').offsetHeight)
          })
        }
      });
    });
    if (buttonwrapper) {
      let getActiveItem = window.sessionStorage.getItem('accountActivetab');
      if (isAccountPage) {
        if (getActiveItem) {
          let target = buttonwrapper.querySelector(`[data-tab-linkto="${getActiveItem}"]`);
          if (target) {
            target.click();
          } else {
            buttonwrapper.querySelector('.js-account-page-tabs').click();
          }
        } else {
          buttonwrapper.querySelector('.js-account-page-tabs').click();
        }
      } else {
        buttonwrapper.querySelector(`[data-tab-linkto="${getActiveItem}"]`).classList.add('active');
        if(tabNameMob){
          tabNameMob.innerHTML = buttonwrapper.querySelector(`[data-tab-linkto="${getActiveItem}"]`).innerHTML
        }
      }
    }
    document.querySelectorAll('[href*="/logout"]').forEach(button => {
      button.addEventListener('click', function () {
        window.sessionStorage.removeItem('accountActivetab');
      });
    })

    window.addEventListener('resize', function () {
      updateButtonWrapper();
      let getActiveItem = window.sessionStorage.getItem('accountActivetab');
      if(getActiveItem) buttonwrapper.querySelector(`[data-tab-linkto="${getActiveItem}"]`).classList.add('active');
    });
  }
}

function setAnnocementHeight() {
  let section = document.querySelector('.utility-bar');
  if (!section) {
    console.error('Section element not found. Check the class name.');
    return;
  }

  let sectionHeight = section.offsetHeight + 'px';
  document.documentElement.style.setProperty('--annocementbar-height', sectionHeight);
}
setAnnocementHeight();
window.addEventListener('resize', setAnnocementHeight);

// =======================================


function outFitImageHeight() {
  let section = document.querySelector('.outfit_image_main');
  if (!section) {
    // console.error('Section element not found. Check the class name.');
    return;
  }

  let sectionHeight = section.offsetHeight + 'px';
  document.documentElement.style.setProperty('--outfit-image-height', sectionHeight);
}
outFitImageHeight();
window.addEventListener('resize', outFitImageHeight);


function setWindowWidth() {
  let windowWidth = window.innerWidth + 'px';
  document.documentElement.style.setProperty('--window-width', windowWidth);
}
setWindowWidth();
window.addEventListener('resize', setWindowWidth);

// filter accordian js
{
  let filterAccordians = document.querySelectorAll('.js-filter-accordian');
  if(filterAccordians.length > 0){
    filterAccordians.forEach((accordian) => {
      accordian.addEventListener('click', function() {
        filterAccordians.forEach((item) => {
          if(item != accordian){
            item.removeAttribute('open');
          }
        });
      });
    });
  }
}

/**
 * Product FancyBox
 */
{
  Fancybox.bind("[data-fancybox]", {
    Thumbs: false,
    Hash: false,
    groupAll:true,
    Images: {
      initialSize: "fit",
      Panzoom: {
        panMode: "mousemove",
        mouseMoveFactor: 1.1,
        mouseMoveFriction: 0.12,
      },
    },
    Toolbar: {
      display: {
        left: [
          // "infobar"
        ],
        middle: [
          // "zoomIn",
          // "zoomOut",
          // "toggle1to1",
          // "rotateCCW",
          // "rotateCW",
          // "flipX",
          // "flipY",
        ],
        right: [
          // "slideshow", 
          // "thumbs", 
          "toggleZoom",
          "close"
        ],
      },
    },
  });
}

let scrollSectionBtn = document.querySelector('.js-scroll-button');

if (scrollSectionBtn) {
  scrollSectionBtn.addEventListener('click', function(e) {
    e.preventDefault();
    if (window.location.pathname !== scrollSectionBtn.getAttribute('href').split('#')[0]) {
      let localStorageValue = `#${scrollSectionBtn.getAttribute('href').split('#')[1]}`
      localStorage.setItem('scrollToSection', localStorageValue);
      window.location.href = scrollSectionBtn.getAttribute('href').split('#')[0];
    }
    else {
      renderContent(`#${scrollSectionBtn.getAttribute('href').split('#')[1]}`);
    } 
  }); 
}

document.addEventListener('DOMContentLoaded', function() {
  let sectionToScroll = localStorage.getItem('scrollToSection');
  if (sectionToScroll) {
    renderContent(sectionToScroll);
    localStorage.removeItem('scrollToSection');
  }
});

function renderContent(sectionId) {
  let headerHeight = parseFloat(document.querySelector('.js-header-height').style.getPropertyValue('--header-height'));
  let renderSection = document.querySelector(sectionId).offsetTop;
        
  window.scrollTo({
    top: renderSection - headerHeight,
    behavior: "smooth",
  });
}

// Birthday popup javascript
{
  if (!customElements.get('bday-popup')) {
    customElements.define(
      'bday-popup',
      class BdayPopup extends HTMLElement {
        constructor() {
          super();
          let SaveDataBtn = this.querySelector('.js-bday-data-submit');
          if(SaveDataBtn){
            SaveDataBtn.addEventListener('click', this.sendBdayData.bind(this));
          }
        }

        async sendBdayData(){
          let selectedMonth = parseInt(this.querySelector('.js-selected-month').value);
          let selectedDate = parseInt(this.querySelector('.js-selected-date').value);
          let gaUserId = this.getAttribute('data-ga-user-id');
          let dataFromPage = this.getAttribute('data-from-page');

          let dateError = this.querySelector('#date-error');
          let monthError = this.querySelector('#month-error');

          if(dateError) dateError.style.display = 'none';
          if(monthError) monthError.style.display = 'none';

          let fnameField = this.querySelector('.js-fname-field');
          let lnameField = this.querySelector('.js-lname-field');
          let emailValueField = this.querySelector('.js-email-value');

          let firstNameValue = '';
          let lastNameValue = '';
          let emailValue = '';
          if(fnameField) firstNameValue = fnameField.value;
          if(lnameField) lastNameValue = lnameField.value;
          if(emailValueField) emailValue = emailValueField.value;

          let fnameError = this.querySelector('#fname-error'); 
          let lnameError = this.querySelector('#lname-error'); 
          let emailError = this.querySelector('#email-error'); 

          if(fnameError) fnameError.style.display = 'none';
          if(lnameError) lnameError.style.display = 'none';
          if(emailError) emailError.style.display = 'none';

          function validateEmail(emailValue) {
            const re = /^[^\s@]+@[^\s@]+$/;
            return re.test(emailValue);
          }

          let isEmailCorrect = false; 
          if(emailValue && validateEmail(emailValue)){
            isEmailCorrect = true;
          }

          if((!firstNameValue || !lastNameValue || !isEmailCorrect) && dataFromPage == 'account'){
            if(!firstNameValue){
              fnameError.style.display = 'block';
            }
            if(!lastNameValue){
              lnameError.style.display = 'block';
            }
            if(!isEmailCorrect){
              emailError.style.display = 'block';
            }
            return;
          }
          
          if ((!selectedMonth || !selectedDate) && dataFromPage != 'account') {
            if (!selectedMonth) {
              this.querySelector('#month-error').style.display = 'block';
            }
            if (!selectedDate) {
              this.querySelector('#date-error').style.display = 'block';
            }
            return; 
          }

          this.querySelector('.js-spinner').classList.remove('hidden');
          this.querySelector('.js-bday-data-submit').classList.add('loading');

          const bodyContent = dataFromPage === 'bday-popup' ? {
            'day': selectedDate,
            'month': selectedMonth,
            'ga_user_id': gaUserId || "",
          } : {
            'day': selectedDate || "",
            'month': selectedMonth || "",
            'ga_user_id': gaUserId || "",
            'first_name': firstNameValue,
            'last_name': lastNameValue,
            'email': emailValue,
          };

          const config = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(bodyContent)
          };

          let saveBdayResponse = await fetch('https://wsapi.halsbrook.com/v3prod/shopify/updatebirthday', config);
          let saveBdayResponseData = await saveBdayResponse.json();
          let responseStatus = saveBdayResponse.ok;
          if(responseStatus){
            this.querySelector('.js-spinner').classList.add('hidden');
            this.querySelector('.js-bday-data-submit').classList.remove('loading');  
            if(dataFromPage == 'bday-popup'){
              sessionStorage.setItem('birthdayPopupShown', 'true');
              this.closest('modal-dialog').hide();
            }   
          }
        }
  
      }
    );
  }
}


// Contact us page API integration
{
  if (!customElements.get('contact-us')) {
    customElements.define(
      'contact-us',
      class ContactUs extends HTMLElement {
        constructor() {
          super();
          let submitFromBtn = this.querySelector('.js-contact-us-submit-btn');
          if(submitFromBtn){
            submitFromBtn.addEventListener('click', this.contactUsData.bind(this));
          }
        }

        async contactUsData(event){
          
          let nameField =  this.querySelector('.js-contact-name-field').value;
          let emailField = this.querySelector('.js-contact-email-field').value;
          let phoneField = this.querySelector('.js-contact-phone-field').value;
          let msgField = this.querySelector('.js-contact-msg-field').value;
          let fullURL = window.location.href;

          if(nameField != '' && phoneField != '' && msgField != ''){
            
            function validateEmail(emailValue) {
              const re = /^[^\s@]+@[^\s@]+$/;
              return re.test(emailValue);
            }

            if(!validateEmail(emailField)) return;
            event.preventDefault();
  
            this.querySelector('.js-spinner').classList.remove('hidden');
            this.querySelector('.js-contact-us-submit-btn').classList.add('loading');  
  
            const config = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                'email': emailField,
                'name': nameField,
                'telephone': phoneField,
                'comment': msgField,
                'referral': fullURL
              })
            };
   
            let response = await fetch('https://wsapi.halsbrook.com/v3prod/shopify/contactus', config);
            let responseData = await response.json();
            let errorElement = this.querySelector('.js-contact-error-element');
            if(responseData.success){
              this.querySelector('.js-spinner').classList.add('hidden');
              this.querySelector('.js-contact-us-submit-btn').classList.remove('loading');  
              errorElement.textContent = 'Your form was submitted successfully';
              errorElement.style.color = 'green';

              this.querySelector('.js-contact-name-field').value = '';
              this.querySelector('.js-contact-email-field').value = '';
              this.querySelector('.js-contact-phone-field').value = '';
              this.querySelector('.js-contact-msg-field').value = '';

              setTimeout(() => {
                errorElement.textContent = '';
              }, 5000);
            }
            else{
              this.querySelector('.js-spinner').classList.add('hidden');
              this.querySelector('.js-contact-us-submit-btn').classList.remove('loading');
              errorElement.textContent = responseData.message;
              errorElement.style.color = 'red';
            }
            
          }
        }
  
      }
    );
  }
}

// Newsletter popup javascript
// {
//   if (!customElements.get('newsletter-sub')) {
//     customElements.define(
//       'newsletter-sub',
//       class NewsletterSub extends HTMLElement {
//         constructor() {
//           super();
//           let submitFromBtn = this.querySelector('.js-email-submit-btn');
//           if(submitFromBtn){
//             submitFromBtn.addEventListener('click', this.sendNewsletter.bind(this));
//           }
//         }

//         async sendNewsletter(event){

//           let nameField = this.querySelector('.js-email-name-field');
//           let lastNameField = this.querySelector('.js-email-last-name-field');
//           let emailField = this.querySelector('.js-email-popup-email-field');
//           let dataFrom = this.getAttribute('data-from-page-part');

//           let nameFieldValue = '';
//           let lastNameFieldValue = '';
//           let emailFieldValue = '';
//           if(nameField) nameFieldValue = nameField.value;
//           if(lastNameField) lastNameFieldValue = lastNameField.value;
//           if(emailField) emailFieldValue = emailField.value;

//           function validateEmail(emailValue) {
//             const re = /^[^\s@]+@[^\s@]+$/;
//             return re.test(emailValue);
//           }

//           let isEmailCorrect = false; 
//           if(emailFieldValue && validateEmail(emailFieldValue)){
//             isEmailCorrect = true;
//           }

//           if((nameFieldValue != '' && lastNameFieldValue != '' && isEmailCorrect && dataFrom == 'email-popup') || (dataFrom == 'footer' && isEmailCorrect )){
//             event.preventDefault();

//             this.querySelector('.js-email-submit-btn').setAttribute('disabled', '');  

//             const bodyContent = dataFrom === 'email-popup' ? {
//               'email': emailFieldValue,
//               'name': nameFieldValue,
//               'lastname': lastNameFieldValue
//             } : {
//               'email': emailFieldValue,
//             };

//             const config = {
//               method: 'POST',
//               headers: {
//                 'Content-Type': 'application/json',
//               },
//               body: JSON.stringify(bodyContent)
//             };

//             let response = await fetch('https://wsapi.halsbrook.com/v3prod/shopify/subscribenews', config);
//             let responseData = await response.json();
//             if(responseData.success){
//               this.querySelector('.js-email-submit-btn').removeAttribute('disabled'); 
//               if(this.querySelector('.js-failure-message')) this.querySelector('.js-failure-message').classList.add('hidden');    
//               if(this.querySelector('.js-success-message')) this.querySelector('.js-success-message').classList.remove('hidden');    
//               if(dataFrom == 'email-popup'){
//                 sessionStorage.setItem('emailSubscriptionPopupShown', 'true');
//                 this.closest('modal-dialog').hide();
//               }
//             }
//             else{
//               this.querySelector('.js-email-submit-btn').removeAttribute('disabled');
//               if(this.querySelector('.js-success-message')) this.querySelector('.js-success-message').classList.add('hidden');
//               if(this.querySelector('.js-failure-message')) this.querySelector('.js-failure-message').classList.remove('hidden');
//               if(dataFrom == 'email-popup'){
//                 if(this.querySelector('.js-popup-failure-message')) this.querySelector('.js-popup-failure-message').classList.remove('hidden');
//               }    
//             }

//           }

//         }
        
//       }
//     );
//   }
// }

// Handle scroll position in safari browser
{
  if(window.matchMedia('(max-width: 989px)').matches){

    function detectBrowser() {
      const userAgent = navigator.userAgent.toLowerCase();
      
      if (userAgent.indexOf('crios') > -1) {
        return 'Chrome (iOS)';  // Indicate Chrome on iOS
      } else if (userAgent.indexOf('safari') > -1 && userAgent.indexOf('chrome') === -1) {
        return 'Safari';
      } else {
        return 'Unknown';
      }
    }

    function isCollectionsPage() {
      return document.body.classList.contains('template-name--collection');
    }
  
    if (isCollectionsPage() && detectBrowser == "Safari") {
      let sessionCollection = sessionStorage.getItem("collection");
      let pathName = window.location.pathname;
      if(!sessionCollection){
        sessionStorage.setItem("collection",pathName);
        sessionStorage.setItem("collectionScrollPosition",window.scrollY);
      }else{
        if(sessionCollection != pathName){
          sessionStorage.setItem("collection",pathName);
          sessionStorage.setItem("collectionScrollPosition",window.scrollY);
        }else{
          const storedScrollPosition = sessionStorage.getItem("collectionScrollPosition");
          if (storedScrollPosition) {
            window.scrollTo(0, parseInt(storedScrollPosition));
          }
        }
      }
      window.addEventListener('scroll',() => {
        sessionStorage.setItem("collectionScrollPosition",window.scrollY);
      });
    }
  }
}

/* macOS-Style scrollbar */
window.addEventListener("DOMContentLoaded", function() {
  const resizeObserver = new ResizeObserver(entries => {
    for (let entry of entries) {
      const visibleWidth = Math.round(entry.contentRect.width);
      const visibleHeight = Math.round(entry.contentRect.height);

      const scrollHeight = Math.round(entry.target.scrollHeight);


      let scrollbar = entry.target._fancyScrollbar;

      if (!scrollbar) {
        scrollbar = document.createElement("div");
        scrollbar.className = "fancy-scrollbar--handler";
        entry.target._fancyScrollbar = scrollbar;
        entry.target._fancyScrollbar._target = entry.target;
        document.body.append(scrollbar);
      }

      if (scrollHeight > visibleHeight) {
        scrollbar._scrollHeight = scrollHeight;
        scrollbar._visibleHeight = visibleHeight;

        const targetTop = Math.round(entry.target.getBoundingClientRect().y);

        scrollbar.style.display = "block";
        scrollbar.style.top = `0px`;
        scrollbar.style.marginTop = `${targetTop}px`;
        scrollbar.style.left = `${entry.target.offsetLeft + visibleWidth + 10}px`;

        let scrollbarHeight = (visibleHeight / scrollHeight) * visibleHeight;
        scrollbar.style.height = `${scrollbarHeight}px`;
        handleElementScrollEvent(entry.target);


        scrollbar.addEventListener("mousedown", scrollbarHandleMouseDown);
      } else {
        scrollbar.style.display = "none";
      }
    }
  });

  function handleElementScrollEvent(elm) {
    if (elm._fancyScrollbar && elm._fancyScrollbar.style.display == "block" && !elm._fancyScrollbar._scrolling) {

      const scrollHeight = elm._fancyScrollbar._scrollHeight;
      const visibleHeight = elm._fancyScrollbar._visibleHeight;

      const scrollTopPercent = Math.min(1, Math.max(0, Math.round(elm.scrollTop) / (scrollHeight - visibleHeight)));
      const scrollbarAvailSpace = visibleHeight - parseFloat(elm._fancyScrollbar.style.height);

      elm._fancyScrollbar.style.top = `${scrollbarAvailSpace * scrollTopPercent}px`;
    }
  };

  const affectedElements = document.querySelectorAll(".fancy-scrollbar");
  for (const elm of affectedElements) {
    resizeObserver.observe(elm);
    elm.addEventListener("scroll", () => handleElementScrollEvent(elm));
  }
  window.addEventListener("scroll", (event) => handlePageScrollEvent(affectedElements, event));
  document.addEventListener("mousemove", scrollbarHandleMouseMove);
  document.addEventListener("mouseup", scrollbarHandleMouseUp);
  window.addEventListener("resize", handlePageResize);


  function handlePageScrollEvent(affectedElements, event) {
    for (const elm of affectedElements) {
      if (elm._fancyScrollbar && elm._fancyScrollbar.style.display == "block") {
        const targetTop = Math.round(elm.getBoundingClientRect().y);
        elm._fancyScrollbar.style.marginTop = `${targetTop}px`;
      }
    }
  }

  let scrollingElement = null;
  function scrollbarHandleMouseDown(event) {
    event.stopPropagation();
    event.preventDefault();

    scrollingElement = event.target;
    scrollingElement._scrolling = true;

    scrollingElement._diffY = event.clientY - parseFloat(scrollingElement.style.top);
    scrollingElement.classList.add("fancy-scrollbar--handler_active");
  }
  function scrollbarHandleMouseUp(event) {
    if (scrollingElement) {
      scrollingElement._scrolling = false;
      scrollingElement.classList.remove("fancy-scrollbar--handler_active");
      scrollingElement = null;
    }
  }
  function scrollbarHandleMouseMove(event) {
    if (scrollingElement) {
      event.stopPropagation();
      event.preventDefault();

      const maxScrollY = scrollingElement._target.getBoundingClientRect().height - parseFloat(scrollingElement.style.height);

      scrollingElement.style.top = Math.min(maxScrollY, Math.max(0, event.clientY - scrollingElement._diffY)) + "px";

      const scrollPercent = Math.round(100 * parseFloat(scrollingElement.style.top) / maxScrollY) / 100;
      const scrollRange = scrollingElement._target.scrollHeight - scrollingElement._target.offsetHeight;

      scrollingElement._target.scrollTo({top: scrollRange * scrollPercent });
    }
  }
  function handlePageResize(event) {
    for (const elm of affectedElements) {
      if (elm._fancyScrollbar && elm._fancyScrollbar.style.display == "block") {

        const visibleWidth = Math.round(elm.getBoundingClientRect().width);
        elm._fancyScrollbar.style.left = `${elm.offsetLeft + visibleWidth + 10}px`;

        // handleElementScrollEvent(elm);
      }
    }
  }
});


// Request a catalog API integration
{
  if (!customElements.get('request-catalog')) {
    customElements.define(
      'request-catalog',
      class RequestCatalog extends HTMLElement {
        constructor() {
          super();
          let submitFromBtn = this.querySelector('.js-request-catalog-submit-btn');
          if(submitFromBtn){
            submitFromBtn.addEventListener('click', this.requestCatalogData.bind(this));
          }
        }

        async requestCatalogData(event){
          let firstName =  this.querySelector('.js-catalog-firstname').value;
          let lastName = this.querySelector('.js-catalog-lastname').value;
          let address1 = this.querySelector('.js-catalog-address1').value;
          let address2 = this.querySelector('.js-catalog-address2').value;
          let city = this.querySelector('.js-catalog-city').value;
          let state = this.querySelector('.js-catalog-state').value;
          let zipCode = this.querySelector('.js-catalog-zip').value;
          let phone = this.querySelector('.js-catalog-phone').value;
          let email = this.querySelector('.js-catalog-email').value;
          let insiderCheckbox = this.querySelector('.js-catalog-insider-checbox');
          let errorElement = this.querySelector('.js-catalog-error-messsage');

          if(firstName != '' && lastName != '' && address1 != '' && city != '' && state != '' && zipCode != '' && phone != '' && email != ''){

            function validateEmail(emailValue) {
              const re = /^[^\s@]+@[^\s@]+$/;
              return re.test(emailValue);
            }

            if(!validateEmail(email)) return;
            
            event.preventDefault();
            this.querySelector('.js-spinner').classList.remove('hidden');
            this.querySelector('.js-request-catalog-submit-btn').classList.add('loading');

            if(insiderCheckbox.checked){
              const bodyContent = {
                'email': email,
                'name': firstName,
                'lastname': lastName
              };
  
              const config = {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(bodyContent)
              };

              /*let emailApiResponse = await fetch('https://wsapi.halsbrook.com/v3prod/shopify/subscribenews', config);
              let emailApiResponseJson = await emailApiResponse.json();
              if(!emailApiResponseJson.success){
                this.querySelector('.js-spinner').classList.add('hidden');
                this.querySelector('.js-request-catalog-submit-btn').classList.remove('loading');
                errorElement.textContent = 'Email is invalid';
                errorElement.style.color = 'red';
                return;
              }*/
            }
            
            const config = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                'firstName': firstName,
                'lastName': lastName,
                'address': address1,
                'address2': address2,
                'state': state,
                'city': city,
                'zipCode': zipCode,
                'email': email,
                'company': 'Halsbrook',
                'phone': phone
              })
            };
  
            let response = await fetch('https://wsapi.halsbrook.com/v3prod/shopify/requestacatalog', config);
            let responseData = await response.json();
            
            if(responseData.success){
              this.querySelector('.js-spinner').classList.add('hidden');
              this.querySelector('.js-request-catalog-submit-btn').classList.remove('loading');
              errorElement.textContent = 'Your form was submitted successfully';
              errorElement.style.color = 'green';

              this.querySelector('.js-catalog-firstname').value = '';
              this.querySelector('.js-catalog-lastname').value = '';
              this.querySelector('.js-catalog-address1').value = '';
              this.querySelector('.js-catalog-address2').value = '';
              this.querySelector('.js-catalog-city').value = '';
              this.querySelector('.js-catalog-state').value = '';
              this.querySelector('.js-catalog-zip').value = '';
              this.querySelector('.js-catalog-phone').value = '';
              this.querySelector('.js-catalog-email').value = '';
              this.querySelector('.js-catalog-insider-checbox').checked = false;
              this.querySelector('.js-request-catalog-submit-btn-text').textContent = 'THANK YOU';

              setTimeout(() => {
                errorElement.textContent = '';
                this.querySelector('.js-request-catalog-submit-btn-text').textContent = 'SUBMIT';
              }, 5000);
            }
            else{
              this.querySelector('.js-spinner').classList.add('hidden');
              this.querySelector('.js-request-catalog-submit-btn').classList.remove('loading');
              errorElement.textContent = responseData.message;
              errorElement.style.color = 'red';
            }
          }
        }
      }
    );
  }
}

// Get Return Label
if (!customElements.get('return-link')) {
  customElements.define(
    'return-link',
    class ReturnLink extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        let returnBtn = this.querySelector('.js-order-return-link');
        if (returnBtn) {
          returnBtn.addEventListener('click', this.returnOrder.bind(this));
        }
      }

      async returnOrder() {
        let returnBtn = this.querySelector('.js-order-return-link');
        let userId = returnBtn.getAttribute('data-user-id');
        let orderId = returnBtn.getAttribute('data-order-id');
        console.log(orderId, userId)

        this.classList.add('disabled');

        const bodyContent = {
          'order_id': orderId,
          'validation_hash': userId
        };

        const config = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(bodyContent)
        };

        try {
          let customerLabelResponse = await fetch('https://wsapi.halsbrook.com/shopify/shopify/customerlabels', config);
          let customerLabelResponseJson = await customerLabelResponse.json();
          if(customerLabelResponseJson.success){
            let urlPath = customerLabelResponseJson.url;
            this.downloadPDF(urlPath);
            this.classList.remove('disabled');
          }
        } catch (error) {
          console.error('Error fetching return label:', error);
        }
      }

      downloadPDF(imageURL) {
         const base64Image = imageURL;
         const { jsPDF } = window.jspdf;
         const pdf = new jsPDF();
         pdf.addImage(base64Image, 'PNG', 0, 0, 105, 148); // (image, format, x, y, width, height)
         pdf.save(`halsbrook-return-${this.dataset.orderId}.pdf`);

        /*const linkSource = `data:application/pdf;base64,${pdf}`;
        const downloadLink = document.createElement("a");
        const fileName = "abc.pdf";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();*/
      }
    }
  );
}

// Fixed footer add to cart button
{
  if(window.matchMedia("(max-width: 989px)").matches){
    let fixedBtnContainer = document.querySelector('.js-fixed-footer-btn-container');
    let fixedBtn = document.querySelector('.js-fixed-footer-btn');
    
    if (fixedBtnContainer && fixedBtn) {
      window.addEventListener('scroll', () => {
        let scrollPosition = window.scrollY;
        let buttonOffset = fixedBtnContainer.offsetTop;
        
        if (scrollPosition > buttonOffset) {
          fixedBtn.classList.add('pdp_footer_btn_fixed');
        } else {
          fixedBtn.classList.remove('pdp_footer_btn_fixed');
        }
      });
    }
  
    if(fixedBtn){
      fixedBtn.addEventListener('click', () => {
        
        let headerHeight = document.querySelector('.js-mob-header-height').offsetHeight;
        let variantContainer = document.querySelector('.js-main-product-variants').offsetTop;

        if(fixedBtn.classList.contains('disabled')){
          window.scrollTo({
            top: variantContainer - headerHeight,
            behavior: "smooth",
          });   
        }

      });
    }
  }
}